$('button#delete-confirm').on('click', function (e) {
    if (!$('input#delete-account').is(":checked")) {
        $('.checkbox-list.delete .switch').addClass('error');

        e.preventDefault();
        return false;
    } else {
        const error_message = $('.account-sidebar__container[data-tab="delete-my-account"] .error__signup')
        $('#customerRemove').on('submit', function (e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/apps/bat-enhanced/customer/delete',
                contentType: 'application/json',
                success: function (response) {
                    if (response.ok) {
                        $('.spinner-container').css('display', 'block');
                        $('.spinner-container').show();
                        setTimeout(function () {
                            $('.spinner-container').css('display', 'none');
                            $('.spinner-container').hide();
                            sessionStorage.clear();
                            window.location.href = theme.routes.logout;
                        }, 3000);
                    } else {
                        console.error(response)
                        error_message.show();
                    }
                },
                error: function (error) {
                    console.log("Error sending data", error);
                    error_message.show();
                }
            });
        });
    }
});
